import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const AnimatedCount = ({ end, suffix }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,     
    threshold: 0.3,       
  });

  return (
    <span ref={ref}>
      {inView ? (
        <CountUp start={0} end={end || 0} duration={2.75} suffix={suffix} />
      ) : (
        0
      )}
    </span>
  );
};

export default AnimatedCount;
